/**
 *  Provide additional navigation data for mixpanel
 **/
export const LINK_CLICK = '@@navigation/LINK_CLICK';

export function linkClick(meta) {
    return { type: LINK_CLICK, meta };
}



/** WEBPACK FOOTER **
 ** /src/shared/actions/navigation.js
 **/